<template>
    <div class="d-flex flex-row h-2em toggle overflow-hidden justify-content-start rounded border cursor-pointer"
         @click="toggle"
    >
        <div :class="{'inactive': !isActive}" class="tile bg-success"><i class="fas fa-check"/></div>
        <div class="tile bg-white"/>
        <div class="tile"><i class="fas fa-times"/></div>
        <input :name="name" type="checkbox" class="d-none" v-model="isActive">
    </div>
</template>

<script>
export default {
    name: 'Toggle',

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            isActive: false,
        }
    },

    mounted() {
        this.isActive = this.active
    },

    methods: {
        toggle() {
            this.isActive = !this.isActive
            this.$emit('change', this.isActive)
        },
    },
}
</script>

<style>
.toggle {
    width: 80px;
}

.inactive {
    margin-left: -50%;
}

.tile {
    width: 50%;
    text-align: center;
    line-height: 15px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    background: #ccc;
    transition: .13s;
}
</style>
